export var SwiftChargeOptions;
(function (SwiftChargeOptions) {
    SwiftChargeOptions["OUR"] = "our";
    SwiftChargeOptions["SHA"] = "sha";
})(SwiftChargeOptions || (SwiftChargeOptions = {}));
